import axios from "axios";
import { API_URL } from "../const";

/** ***************** GET COUNTRY  LIST START *********************** */
export const getAllCountryList = (country: any) => {
  const data = {
    GetCountryListToken: country,
  };
  const url = `${API_URL}fetchCountryList`;
  return axios.post(url, data, {
    headers: { "Content-type": "application/json" },
  });
};
/** ***************** GET COUNTRY LIST END *********************** */

/** ***************** FETCH STATE LIST START *********************** */
export const fetchCountryStateList = (country: any) => {
  const data = {
    CountryStateListGetToken: country,
  };
  const url = `${API_URL}fetchCountryStateList`;
  return axios.post(url, data, {
    headers: { "Content-type": "application/json" },
  });
};
/** ***************** FETCH STATE LIST END *********************** */

/** ***************** FETCH STATE CITY LIST START *********************** */
export const fetchStateCityList = (country: any) => {
  const data = {
    StateCityListGetToken: country,
  };
  const url = `${API_URL}fetchStateCityList`;
  return axios.post(url, data, {
    headers: { "Content-type": "application/json" },
  });
};
/** ***************** FETCH STATE CITY LIST END *********************** */
